/* eslint-disable max-len */
import { Alert, Box, Divider, Grid, Typography, styled } from "@mui/material";
import { Field, Form } from "react-final-form";
import { Section, SectionRow } from "../Scan";
import TextFieldControlSimple from "../../components/FormComponents/TextField.component";
import FormValidators from "../../utils/form-validators";
import { createForm, FormApi } from "final-form";
import { useCallback, useEffect, useRef, useState } from "react";
import { ActionBtn, Text } from "../../components/Typography";
import useAuthorization from "../../contexts/useAuthorization";
import { useAxios } from "../../services/http.service";
import ApiRoutes from "../../config/api.routes";
import { consoleError, consoleLog, getAvailableCountriesList, sizing, sleep } from "../../utils/methods";
import SelectFieldControl from "../../components/FormComponents/SelectField.component";
import { BlogStoryBlock } from "../../components";
import PalmTree from "../../assets/palm.jpg";
import InfoIconOutlined from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import DocUploadNew from "../Scan/components/DocUploadNew";
import { AppRoutes } from "../../config/app.routes";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { posters } from "../SupportCenter/BlogStories";
import { Trending } from "../Home/Home";
import ProfilePictureUpload from "../../components/ProfilePictureUpload";
import ProofOfIdUpload from "../../components/ProofOfIdUpload";
import { useProfileDataCache } from "../../contexts";
import { KycStatus } from "../../types/User";
import SelfieCaptureStep from "./kyc/SelfieCaptureStep";
import DocumentUploadStep from "./kyc/DocumentUploadStep";
import KycStepper from "./kyc/KycStepper";
import { dataUrlToFile, type DocumentUpload, type SelfieCapture } from "./kyc/types";
import { WetInkFlow, DocumentType } from "../../components/DigitalSignature";
import VerifierEngagementStep, { findOwnSignedEngagementId } from "./VerifierEngagementStep";

// const typeOptions = [
//   { label: "Ecological organization", value: "Ecological organization" },
//   { label: "Individual assessor", value: "Individual assessor" },
//   // { label: "International ecological body", value: "International ecological body" },
// ];

type TrustForm = {
  name: string;
  type: string;
  email: string;
  address: string;
  country: string;
  countryCode: number;
  website: string;
  phone: string;
  phoneCode: string;
  primaryWallet: string;
  userPhone: string;
  userPhoneCode: string;
  userName: string;
  userCountry: string;
  userCountryCode: string;
  patronymic: string;
  userEmail?: string;
};

const UnauthorizedComponent = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        height: "400px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div
        style={{ width: "100%", color: "darkslategrey", marginBottom: "-30px", fontSize: "80px", textAlign: "center" }}
      >
        401
      </div>
      <div style={{ width: "100%", fontSize: "40px", textAlign: "center" }}>Unauthorized</div>
      <div style={{ width: "100%", textAlign: "center", color: "orange", marginBottom: "10px" }}>
        You are not authorized to access this page. Only invited trustees and admins can access this page.
      </div>
      <Button onClick={() => navigate(AppRoutes.Home.path)}>Go Home</Button>
    </div>
  );
};

const BecomeTrust = () => {
  const axios = useAxios();
  const { user, isAdmin, isGuardian, isPioneer, isTrust, setUser, fetchUser } = useAuthorization();
  const { refreshProfileData } = useProfileDataCache();
  // const [infoClosed, setInfoClosed] = useState(false);
  const [formStep, setFormStep] = useState(1);
  const [proofOfAddress, setProofOfAddress] = useState<File | undefined>(undefined);
  const initialProofOfAddressRef = useRef<File | undefined>(undefined);
  const [initialForm, setInitialForm] = useState<any>(undefined);
  const [countriesList, setCountriesList] = useState([]);
  const [codes, setCodes] = useState([]);
  const [profilePic, setProfilePic] = useState<File | undefined>(undefined);
  const [profilePicUploaded, setProfilePicUploaded] = useState<boolean>(false);
  const [regions, setRegions] = useState([]);

  const [loading, setLoading] = useState<boolean>(false);
  const [formSuccess, setFormSuccess] = useState<boolean>(false);
  const [formError, setFormError] = useState<string>("");
  const [country, setCountry] = useState("");

  // Trust Admin applicants only: the wet-ink deed (hand-signed scan) must be uploaded and verified
  // before the application can be confirmed.
  const [hasCompletedWetInk, setHasCompletedWetInk] = useState<boolean>(false);
  // Verifier applicants only: the Verifier Engagement must be signed before the application can be
  // confirmed. This holds one signed during this visit; one from an earlier visit is on the user.
  const [signedEngagementId, setSignedEngagementId] = useState<number | null>(null);

  // Native KYC state
  const [kycError, setKycError] = useState<string>("");
  const [kycSubmitting, setKycSubmitting] = useState<boolean>(false);
  const [requestId, setRequestId] = useState<string | null>(null);
  const [selfieCapture, setSelfieCapture] = useState<SelfieCapture | null>(null);
  const [creatingApplicant, setCreatingApplicant] = useState<boolean>(false);
  const [createApplicantError, setCreateApplicantError] = useState<{
    status?: number;
    message: string;
  } | null>(null);
  const [kycPassed, setKycPassed] = useState<boolean | null>(null);
  const [kycFailureReasons, setKycFailureReasons] = useState<string[] | null>(null);
  // Set as soon as /kyc/submit succeeds, so the document step swaps to the
  // pending screen immediately — without waiting for fetchUser() to report
  // KYC_PENDING (the backend may lag a poll cycle behind).
  const [kycSubmitted, setKycSubmitted] = useState<boolean>(false);
  const kycPollTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const fetchRegions = async () => {
    const targetCountry = user?.country || country;

    if (targetCountry) {
      try {
        const res = await axios.get(ApiRoutes.user.getRegions(targetCountry)).then((response) => response.data);
        console.log({ res });
        const regions = res.map((region: any) => ({
          ...region,
          value: region,
          label: region,
        }));
        console.log({ regions });
        setRegions(regions);
      } catch (e) {
        console.error("Failed to fetch regions:", e);
      }
    }
  };

  useEffect(() => {
    fetchRegions();
  }, [country, user]);

  const stopKycPolling = useCallback(() => {
    if (kycPollTimerRef.current) {
      clearTimeout(kycPollTimerRef.current);
      kycPollTimerRef.current = null;
    }
  }, []);

  const pollKycStatus = useCallback(async () => {
    try {
      const res = await axios.get(ApiRoutes.user.verification.kyc.status);
      const record = res.data;
      if (!record) {
        kycPollTimerRef.current = setTimeout(() => void pollKycStatus(), 5000);
        return;
      }
      if (record.status === "completed" || record.status === "failed") {
        setKycPassed(record.kycPassed ?? null);
        setKycFailureReasons(record.failureReasons ?? null);
        // Result is in — clear the post-submit flag so the pending screen
        // hands off to user.kycStatus (VERIFIED → success, DECLINED → retry)
        // and the polling effect doesn't immediately restart.
        setKycSubmitted(false);
        await fetchUser();
        stopKycPolling();
        return;
      }
      kycPollTimerRef.current = setTimeout(() => void pollKycStatus(), 5000);
    } catch (e) {
      consoleError("Failed to poll KYC status", e);
      kycPollTimerRef.current = setTimeout(() => void pollKycStatus(), 5000);
    }
  }, [axios, fetchUser, stopKycPolling]);

  useEffect(() => stopKycPolling, [stopKycPolling]);

  // Poll while a verification is outstanding — either we've just submitted
  // (kycSubmitted) or the user is already in KYC_PENDING (e.g. page reload).
  // Polling stops itself once the status record comes back completed/failed.
  useEffect(() => {
    const shouldPoll = kycSubmitted || user?.kycStatus === KycStatus.KYC_PENDING;
    if (shouldPoll && !kycPollTimerRef.current) {
      void pollKycStatus();
    }
    if (!shouldPoll) {
      stopKycPolling();
    }
  }, [kycSubmitted, user?.kycStatus, pollKycStatus, stopKycPolling]);

  const handleCreateApplicant = useCallback(async (): Promise<boolean> => {
    setCreateApplicantError(null);
    setCreatingApplicant(true);
    try {
      const applicant = await axios.post(ApiRoutes.user.verification.kyc.createApplicant).then((res) => res.data);
      const id = applicant?.request_id;
      if (!id) {
        setCreateApplicantError({ message: "Failed to start verification. Please try again." });
        return false;
      }
      setRequestId(id);
      return true;
    } catch (e: any) {
      const status = e?.response?.status;
      const message = e?.response?.data?.message || "Failed to start verification. Please try again.";
      consoleError("Failed to create KYC applicant", e);
      setCreateApplicantError({ status, message });
      return false;
    } finally {
      setCreatingApplicant(false);
    }
  }, [axios]);

  const handleSelfieCapture = useCallback((selfie: SelfieCapture) => {
    setSelfieCapture(selfie);
    setFormStep((s) => s + 1);
  }, []);

  const handleDocumentSubmit = useCallback(
    async (document: DocumentUpload) => {
      setKycError("");
      if (!selfieCapture) {
        setKycError("Please complete the liveliness check first.");
        return;
      }
      if (!requestId) {
        setKycError("Verification session is missing. Please go back and start again.");
        return;
      }
      setKycSubmitting(true);
      try {
        const formData = new FormData();
        formData.append("request_id", requestId);
        formData.append("selfie", dataUrlToFile(selfieCapture.imageDataUrl, "selfie.jpg"), "selfie.jpg");
        const front = document.frontImage;
        const ext = front.type.split("/")[1] || "jpg";
        formData.append("document", dataUrlToFile(front.dataUrl, `document.${ext}`), `document.${ext}`);

        await axios.post(ApiRoutes.user.verification.kyc.submit, formData);

        setKycPassed(null);
        setKycFailureReasons(null);
        // Stay on the document step — its JSX swaps to the pending/verified
        // status cards. kycSubmitted forces the pending screen right away and
        // also starts the polling effect; user.kycStatus takes over once
        // fetchUser()/polling catches up.
        setKycSubmitted(true);
        await fetchUser();
      } catch (e: any) {
        consoleError("Native KYC submission failed", e);
        setKycError(e?.response?.data?.message || "Failed to submit verification. Please try again.");
      } finally {
        setKycSubmitting(false);
      }
    },
    [axios, fetchUser, requestId, selfieCapture]
  );

  const handleUploadPicture = async () => {
    if (profilePic) {
      setLoading(true);
      await sleep(1000);

      const formData = new FormData();
      formData.append("profile_picture", profilePic);
      try {
        const response = await axios.patch(ApiRoutes.user.profile.picture, formData);
        console.log({ response });
        setUser((prevUser: any) => ({
          ...prevUser,
          profilePicture: response.data.profilePicture,
        }));
        setProfilePicUploaded(true);
      } catch (e: any) {
        console.log({ error: e });
      } finally {
        setLoading(false);
      }
    }
    return true;
  };

  const handleDeletePicture = async () => {
    setLoading(true);
    setProfilePicUploaded(false);
    await sleep(1000);

    try {
      const response = await axios.delete(ApiRoutes.user.profile.picture);
      console.log({ response });
      setUser(response.data);
    } catch (e: any) {
      console.log({ error: e });
    } finally {
      setLoading(false);
    }
    return true;
  };

  useEffect(() => {
    getAvailableCountriesList(axios, setCountriesList);
    getCountryCodes();
    if (user?.address) {
      // Check if there's saved form data in localStorage
      const savedFormData = localStorage.getItem("becomeTrustFormData");
      const parsedData = savedFormData ? JSON.parse(savedFormData) : null;

      setInitialForm({
        primaryWallet:
          parsedData?.primaryWallet ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited"
            ? user.address
            : user.organization?.primaryWallet),
        userEmail: parsedData?.userEmail || user?.email,
        userName: parsedData?.userName || user?.name,
        userCountry: parsedData?.userCountry || user?.country,
        userPhoneCode: parsedData?.userPhoneCode || user?.phone?.split("-")[0],
        userCountryCode: parsedData?.userCountryCode || 0,
        userPhone: parsedData?.userPhone || user?.phone?.split("-")[1],
        name:
          parsedData?.name ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user.organization?.name),
        type:
          parsedData?.type ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user.organization?.type),
        email:
          parsedData?.email ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user.organization?.email),
        address:
          parsedData?.address ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user.organization?.address),
        country:
          parsedData?.country ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user.organization?.country),
        website:
          parsedData?.website ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user.organization?.website),
        phone:
          parsedData?.phone ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited"
            ? null
            : user.organization?.phone?.split("-")[1]),
        phoneCode:
          parsedData?.phoneCode ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited"
            ? null
            : user.organization?.phone?.split("-")[0]),
        countryCode:
          parsedData?.countryCode ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited"
            ? null
            : user.organization?.countryCode),
        patronymic:
          parsedData?.patronymic ||
          (user?.trusteeStatus === null && user?.trustAdminStatus !== "invited" ? null : user?.patronymic),
      });

      if (
        user?.trusteeStatus === "invited" ||
        user?.trusteeStatus === "declined" ||
        user?.trustAdminStatus === "invited" ||
        user?.trustAdminStatus === "declined" ||
        user?.trustStatus === "declined"
      ) {
        if (typeof user?.organization?.proofOfAddress === "string") {
          const proofOfAddressFile = new File([user.organization.proofOfAddress], "proofOfAddress");
          setProofOfAddress(proofOfAddressFile);
          initialProofOfAddressRef.current = proofOfAddressFile;
        } else {
          setProofOfAddress(undefined);
          initialProofOfAddressRef.current = undefined;
        }
      }
    }
  }, [user]);

  const nextFormStep = () => {
    setFormStep(formStep + 1);
  };

  const prevFormStep = () => {
    setFormStep(formStep - 1);
  };

  const getCountryCodes = async () => {
    try {
      const res = await axios.get(ApiRoutes.user.getAvailableCountries).then((response) => response.data);

      const sortedCountries = res.sort((a: any, b: any) => {
        if (a.name.common < b.name.common) return -1;
        if (a.name.common > b.name.common) return 1;
        return 0;
      });

      setCodes(
        sortedCountries.map((country: any) => {
          return {
            label: country.name.common + " | " + country.idd.root + country.idd.suffixes[0],
            value: country.idd.root + country.idd.suffixes[0],
            icon: country.flags.svg,
          };
        })
      );
    } catch (e: any) {
      console.error(e);
    }
  };

  const onSubmit = async (values: TrustForm) => {
    setLoading(true);
    setFormSuccess(false);
    setFormError("");
    consoleLog({ values, proofOfAddress });
    const formData = new FormData();
    const userFormData = new FormData();
    const organizationValues = {
      name: values.name,
      type: "Ecological organization",
      email: values.email,
      address: values.address,
      country: values.country,
      website: values.website,
      phone: values.phoneCode + "-" + values.phone,
      // countryCode: values.countryCode,
      primaryWallet: values.primaryWallet,
    };
    userFormData.append("name", values.userName);
    userFormData.append("phone", values.userPhoneCode + "-" + values.userPhone);
    userFormData.append("country", values.userCountry);
    // userFormData.append("countryCode", values.userCountryCode);
    if (values.patronymic) {
      userFormData.append("patronymic", values.patronymic);
    }

    if (proofOfAddress) {
      formData.append("proof_of_address", proofOfAddress, `proofOfAddress_${values.name.replaceAll("s", "_")}`);
    }
    formData.append("organization", JSON.stringify(organizationValues));

    // PUT /trust/updateOrganization expects flat multipart fields, not the JSON-wrapped
    // "organization" payload that POST /trust/becomeTrust takes.
    const updateOrgFormData = new FormData();
    if (proofOfAddress) {
      updateOrgFormData.append(
        "proof_of_address",
        proofOfAddress,
        `proofOfAddress_${values.name.replaceAll("s", "_")}`
      );
    }
    updateOrgFormData.append("name", organizationValues.name);
    updateOrgFormData.append("type", organizationValues.type);
    updateOrgFormData.append("email", organizationValues.email);
    updateOrgFormData.append("address", organizationValues.address);
    updateOrgFormData.append("country", organizationValues.country);
    updateOrgFormData.append("website", organizationValues.website);
    updateOrgFormData.append("phone", organizationValues.phone);

    const currentOrganization = user?.organization;
    const hasOrganizationChanges =
      organizationValues.name !== currentOrganization?.name ||
      organizationValues.type !== currentOrganization?.type ||
      organizationValues.email !== currentOrganization?.email ||
      organizationValues.address !== currentOrganization?.address ||
      organizationValues.country !== currentOrganization?.country ||
      organizationValues.website !== currentOrganization?.website ||
      organizationValues.phone !== currentOrganization?.phone ||
      proofOfAddress !== initialProofOfAddressRef.current;

    const shouldUpdateOrganization = isDeclinedOrgCreator && hasOrganizationChanges;

    // Declined org-creators must stay on the org update path even if they also
    // carry invited/declined trustee flags from the backend.
    if (isInvitedTrustee && !isDeclinedOrgCreator) {
      try {
        const user = await axios.patch(ApiRoutes.user.root, userFormData);
        if (user) {
          consoleLog("User updated", user);
          const verification = await axios.post(ApiRoutes.user.acceptTrustee).then((res) => res.data);
          if (verification) {
            consoleLog("Verification accepted", verification);
            setFormSuccess(true);
            await refreshProfileData();
            // Clear saved form data on successful submission
            localStorage.removeItem("becomeTrustFormData");
            //navigator(AppRoutes.Profile.subRoutes.Identification.path);
            window.location.href = AppRoutes.Profile.subRoutes.Identification.path;
          }
        } else {
          // try again
          await sleep(1500);
          setLoading(false);
          consoleError("Failed submit user", user);
          setFormError("Failed to submit user information.");
          return;
        }
      } catch (e: any) {
        await sleep(1500);
        setLoading(false);
        consoleError(e);
        setFormError("Failed to submit organization information.");
      }
    } else {
      try {
        // Declined org-creators only update the organization when something changed.
        // First-time creators still create a new organization as before. Invited
        // admins create their own Trust Admin org (trustAdminStatus flips to
        // "accepted" server-side on success — no separate accept call needed).
        const orgRequest = isInvitedAdmin
          ? axios.post(ApiRoutes.admin.becomeTrustAdminOrg, formData).then((res) => res.data)
          : isDeclinedOrgCreator
          ? shouldUpdateOrganization
            ? axios.put(ApiRoutes.trust.organization, updateOrgFormData).then((res) => res.data)
            : Promise.resolve(null)
          : axios.post(ApiRoutes.trust.becomeTrust, formData).then((res) => res.data);
        const userRequest = axios.patch(ApiRoutes.user.root, userFormData);
        const [organization, user] = await Promise.all([orgRequest, userRequest]);
        if (user && (organization || isDeclinedOrgCreator)) {
          if (organization) {
            consoleLog(shouldUpdateOrganization ? "Organization updated" : "Organization created", organization);
          }
          consoleLog("User updated", user);
          if (isDeclinedOrgCreator) {
            const verification = await axios.post(ApiRoutes.user.acceptTrustee).then((res) => res.data);
            consoleLog("Verification accepted", verification);
          }
          await refreshProfileData();
          // Clear saved form data on successful submission
          localStorage.removeItem("becomeTrustFormData");
          //navigator(AppRoutes.Profile.subRoutes.Identification.path);
          window.location.href = AppRoutes.Profile.subRoutes.Identification.path;
        } else {
          await sleep(1500);
          setLoading(false);
          consoleError("Failed submit organization", organization);
          consoleError("Failed submit user", user);
          setFormError("Failed to submit organization information. " + (organization?.response?.data?.message || ""));
          setFormError("Failed to submit user information.");
          return;
        }
      } catch (e: any) {
        await sleep(1500);
        setLoading(false);
        consoleError(e);
        // Surface the duplicate-org 400 from POST /trust/becomeTrust (and the
        // trust-admin variant) with actionable copy; fall back to the backend
        // message for anything else it reports.
        const backendMessage = e?.response?.data?.message;
        setFormError(
          backendMessage === "Organization already exists"
            ? `An organization with the email "${values.email}" is already registered. Go back to the Organization step, change the organization's Email field to a different address, and confirm again.`
            : "Failed to submit organization information." + (backendMessage ? ` ${backendMessage}` : "")
        );
      }
    }
  };

  const formAPI: FormApi<TrustForm, any> = createForm({
    initialValues: initialForm,
    validateOnBlur: false,
    mutators: {
      setSize: (values, state, { changeValue }) => {
        changeValue(state, "size", () => values[0]);
      },
      setDeed: (values, state, { changeValue }) => {
        changeValue(state, "deedCheck", () => values[0]);
      },
    },
    onSubmit: onSubmit,
  });

  // Simple approach to save form values in localStorage during form changes
  const saveFormToLocalStorage = (values: any) => {
    if (values) {
      localStorage.setItem("becomeTrustFormData", JSON.stringify(values));
    }
  };
  // KYC step layout depends on kycStatus:
  //   REQUIRED / DECLINED → two capture steps: Liveliness, Document
  //   PENDING / VERIFIED  → single merged "KYC Status" step
  //   NOT_REQUIRED / undefined → no KYC steps
  const needsKycCapture = user?.kycStatus === KycStatus.KYC_REQUIRED || user?.kycStatus === KycStatus.KYC_DECLINED;
  const showsKycStatusStep = user?.kycStatus === KycStatus.KYC_PENDING || user?.kycStatus === KycStatus.KYC_VERIFIED;
  const kycStepCount = needsKycCapture ? 2 : showsKycStatusStep ? 1 : 0;

  // Invited to join an existing trust org — org fields are prefilled and locked.
  // "declined" users are allowed to re-enter and resubmit, so we treat them the same.
  const isInvitedTrustee = user?.trusteeStatus === "invited" || user?.trusteeStatus === "declined";
  // Invited to create an org as the trust admin — fills out the org form themselves.
  const isInvitedTrusteeOrgAdmin = user?.trustStatus === "invited" || user?.trustStatus === "declined";
  const isInvitedAdmin = user?.trustAdminStatus === "invited" || user?.trustAdminStatus === "declined";
  // Org-creators who were previously declined need to re-upload proof of organization
  // (the prior file on user.organization is stale and should be replaced).
  const isDeclinedOrgCreator = user?.trustStatus === "declined";

  // Each path signs one thing before confirming:
  //   Trust Admin → the conservation trust deed, in wet ink.
  //   Verifier    → (org-joiner or org-creator) the Verifier Engagement and Service Agreement,
  //                 with their wallet. That's all they sign: the admin reviewing the application
  //                 executes the Deed of Appointment of Sub-Attorney with them
  //                 (components/ApplicantReview), and once approved they're a Verifier.
  const signsEngagement = !isInvitedAdmin;

  // Step indexes (1-based):
  //   1 = Intro / Get Started
  //   2..(1+kycStepCount) = KYC step(s)
  //   then User Info, Org Info, Wet-Ink Signing (Trust Admins) or Sign Agreement (Verifiers), Confirm
  // Steps a path doesn't have are -1, so no formStep ever matches them.
  const livelinessStep = needsKycCapture ? 2 : -1;
  const documentStep = needsKycCapture ? 3 : -1;
  const kycStatusStep = showsKycStatusStep ? 2 : -1;
  const userInfoStep = 2 + kycStepCount;
  const orgInfoStep = 3 + kycStepCount;
  const wetInkStep = signsEngagement ? -1 : 4 + kycStepCount;
  const signAgreementStep = signsEngagement ? 4 + kycStepCount : -1;
  const confirmStep = 5 + kycStepCount;

  const isOnKycStatusStep = showsKycStatusStep && formStep === kycStatusStep;

  const isKycBlockedAtConfirmStep =
    formStep === confirmStep &&
    (user?.kycStatus === KycStatus.KYC_PENDING || user?.kycStatus === KycStatus.KYC_DECLINED);

  const kycConfirmStepMessage =
    user?.kycStatus === KycStatus.KYC_DECLINED
      ? "Identity verification is declined. Please complete a new verification before confirming."
      : "Identity verification is pending. Please wait until the verification is completed before confirming.";

  // Wet-ink deed to hand-sign on the wet-ink step — reached only by Trust Admins, who sign the
  // conservation trust deed. (A Verifier's sub-attorney deed is the reviewing admin's to execute.)
  const wetInkDocumentType = DocumentType.CONSERVATION_TRUST_DEED;

  // Pre-fill the handful of deed placeholders we actually know from onboarding — the org's legal
  // name, its address, and the applicant signing on its behalf. Everything else (notary, witnesses,
  // stamp duty, registration/instrument numbers, execution date) is completed in wet ink at signing.
  // Keys must be bare placeholder names valid for the template (the backend rejects unknown keys).
  // Empty values are omitted so the placeholder survives for physical completion rather than being
  // blanked out.
  const buildWetInkTemplateVars = (values: Partial<TrustForm> | undefined): Record<string, string> => {
    const orgName = values?.name || user?.organization?.name || "";
    const orgAddress = values?.address || user?.organization?.address || "";
    const signatory = values?.userName || user?.name || "";
    const entries: Record<string, string> = {
      CONSERVATION_TRUST_FULL_LEGAL_NAME: orgName,
      CONSERVATION_TRUST_ADDRESS: orgAddress,
      CONSERVATION_TRUST_SIGNATORY: signatory,
    };
    return Object.fromEntries(Object.entries(entries).filter(([, v]) => v.trim().length > 0));
  };

  const buttonDisabled = (invalid: boolean) => {
    if (formStep === 1) {
      if (loading || creatingApplicant || !user || !user?.emailVerified) return true;
      // If create-applicant returned a hard error (already verified / email not verified),
      // disable Get Started until the underlying state changes.
      if (createApplicantError && (createApplicantError.status === 400 || createApplicantError.status === 403)) {
        return true;
      }
      return false;
    }
    if (isOnKycStatusStep) {
      // Merged KYC Status step: only allow proceeding if VERIFIED
      return user?.kycStatus !== KycStatus.KYC_VERIFIED;
    }
    if (needsKycCapture && formStep === documentStep) {
      // Outer Next on the document step is only shown post-submission. Block until
      // the provider has returned kycPassed === true (user becomes KYC_VERIFIED).
      return user?.kycStatus !== KycStatus.KYC_VERIFIED;
    }
    if (formStep === userInfoStep) {
      return loading || invalid || (!user.profilePicture && !profilePicUploaded);
    }
    if (formStep === orgInfoStep) {
      // Invited trustees join an existing org — fields are prefilled / disabled,
      // so they only need to wait for the request to settle. Everyone else
      // (including invited admins, who create their own org, invited org-creators,
      // and declined org-creators editing their own org) must pass form validity
      // and upload proof of organization.
      if (isInvitedTrustee && !isDeclinedOrgCreator) {
        return loading;
      }
      return loading || invalid || !proofOfAddress;
    }
    if (formStep === wetInkStep) {
      // Can't advance to confirmation until the wet-ink deed scan is verified.
      return !hasCompletedWetInk;
    }
    if (formStep === signAgreementStep) {
      // Can't advance to confirmation until the verifier engagement is signed.
      return signedEngagementId == null && findOwnSignedEngagementId(user) == null;
    }
    if (isKycBlockedAtConfirmStep) {
      return true;
    }
    return loading || formSuccess;
  };

  if (!user) {
    return null;
  }

  const isInvited = isInvitedTrusteeOrgAdmin || isInvitedTrustee || isInvitedAdmin;

  if (isInvited) {
    // Build stepper labels dynamically based on KYC state
    const kycLabels = needsKycCapture
      ? ["Liveliness Check", "NIC/Passport/Driver License Check"]
      : showsKycStatusStep
      ? ["KYC Status"]
      : [];
    const stepperLabels = [
      ...kycLabels,
      "Account Info",
      "Organization",
      signsEngagement ? "Sign Agreement" : "Wet-Ink Signing",
      "Confirm",
    ];

    // Map formStep to stepper active index (0-based). Stepper labels exclude
    // the "Get Started" intro, so formStep 2 maps to index 0.
    const stepperActiveIndex = formStep - 2;

    return (
      <Grid container>
        <StyledGrid flexDirection="column">
          <FormContainer
            sx={{
              // pb: { xs: "18px", md: "24px" },
              // px: { xs: "18px", md: "24px" },
              backgroundColor: formStep === 1 || formStep === confirmStep ? "back.light" : "white",
              borderRadius: "20px",
            }}
          >
            <Form
              form={formAPI}
              initialValues={initialForm}
              subscription={{
                pristine: true,
                invalid: true,
                active: true,
                values: true,
                valid: true,
                validating: true,
                errors: true,
                modified: true,
              }}
              onSubmit={
                !isAdmin && !isGuardian && !isPioneer && !isTrust ? onSubmit : () => console.log("Unauthorized")
              }
              render={({ handleSubmit, form, invalid, values }) => {
                // Save form values to localStorage whenever they change
                if (values) {
                  saveFormToLocalStorage(values);
                }

                return (
                  <FormArea
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && (e.target as any).nodeName !== "TEXTAREA") {
                        e.preventDefault();
                      }
                    }}
                  >
                    {formStep !== 1 && (
                      <Box sx={{ width: "100%" }}>
                        <KycStepper steps={stepperLabels} activeIndex={stepperActiveIndex} />
                      </Box>
                    )}

                    {formStep === 1 && (
                      <InfoContainer
                        sx={{
                          backgroundColor: "back.light",
                          borderRadius: "20px",
                          padding: { xs: "18px 18px 0px 18px", md: "24px 24px 0px 24px" },
                        }}
                      >
                        <Grid container spacing={{ xs: 3, md: 2 }} alignItems="flex-start">
                          <Grid item xs={12} md={6}>
                            <p
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 700,
                                fontSize: "26px",
                                lineHeight: "31.2px",
                                color: "black",
                                margin: 0,
                                marginBottom: "23px",
                              }}
                            >
                              Important
                            </p>
                            <p
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 700,
                                fontSize: "18px",
                                lineHeight: "21.6px",
                                color: "black",
                                margin: 0,
                                marginBottom: "12px",
                              }}
                            >
                              Before you begin the process, make sure you have the following:
                            </p>
                            <ul
                              style={{
                                paddingLeft: "20px",
                                marginTop: "0",
                                marginBottom: "0",
                                listStyleType: "disc",
                              }}
                            >
                              <li style={{ marginBottom: "8px" }}>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "19.2px",
                                    color: "black",
                                    margin: 0,
                                  }}
                                >
                                  Connected Digital Wallet
                                </p>
                              </li>
                              <li style={{ marginBottom: "8px" }}>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "19.2px",
                                    color: "black",
                                    margin: 0,
                                  }}
                                >
                                  Verified Email
                                </p>
                              </li>
                              <li style={{ marginBottom: "8px" }}>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "19.2px",
                                    color: "black",
                                    margin: 0,
                                  }}
                                >
                                  Proof of Registered Environmental Organization
                                </p>
                              </li>
                              <li style={{ marginBottom: "8px" }}>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "19.2px",
                                    color: "black",
                                    margin: 0,
                                  }}
                                >
                                  Live website for the environmental organization registration
                                </p>
                              </li>
                              <li>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "19.2px",
                                    color: "black",
                                    margin: 0,
                                  }}
                                >
                                  Camera access enabled (disable any security settings blocking access)
                                </p>
                              </li>
                            </ul>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Box
                              sx={{
                                width: "100%",
                                backgroundColor: "back.infoCard",
                                borderRadius: "16px",
                                p: { xs: "16px", md: "18px 24px 30px 24px" },
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                                ml: { xs: 0, md: "auto" },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: { xs: "12px", md: "16px" },
                                }}
                              >
                                <Box
                                  sx={{
                                    flexShrink: 0,
                                    backgroundColor: "#d1efff",
                                    borderRadius: "26px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: { xs: "44px", md: "52px" },
                                    height: { xs: "44px", md: "52px" },
                                  }}
                                >
                                  <InfoIconOutlined sx={{ fontSize: { xs: "24px", md: "28px" } }} color="primary" />
                                </Box>
                                <p
                                  style={{
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    lineHeight: "19.2px",
                                    textTransform: "uppercase",
                                    color: "black",
                                    margin: 0,
                                    flex: 1,
                                    minWidth: 0,
                                  }}
                                >
                                  Why {isInvitedAdmin ? "Trust Admins" : "Trustees"} are not permitted to trade
                                  EcoFutures?
                                </p>
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "12px",
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    color: "black",
                                    margin: 0,
                                  }}
                                >
                                  {isInvitedAdmin
                                    ? `Trust Admins are custodians of governance and oversight, so they are restricted from trading to avoid conflicts of interest. Their role is to safeguard transparency and ensure fair stewardship rather than participate in market activity.`
                                    : `Trustees are responsible for verifying and scoring lands, ensuring impartial evaluation of ecological value. Because their role is to safeguard integrity, they are restricted from trading to prevent conflicts of interest.`}
                                </p>
                                <a
                                  href={AppRoutes.About.path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    color: "black",
                                    textDecoration: "underline",
                                    textUnderlineOffset: "2px",
                                  }}
                                >
                                  Read More
                                </a>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                        {createApplicantError && (
                          <Alert
                            severity={
                              createApplicantError.status === 400
                                ? "success"
                                : createApplicantError.status === 403
                                ? "warning"
                                : "error"
                            }
                            sx={{ mt: 2, borderRadius: "10px" }}
                          >
                            {createApplicantError.status === 400
                              ? "You are already verified. No further action needed."
                              : createApplicantError.status === 403
                              ? "Please verify your email before continuing with identity verification."
                              : createApplicantError.message}
                          </Alert>
                        )}
                      </InfoContainer>
                    )}
                    {/* ── KYC: Liveliness Check (REQUIRED / DECLINED only) ── */}
                    {needsKycCapture && formStep === livelinessStep && (
                      <Box>
                        {user?.kycStatus === KycStatus.KYC_DECLINED && (
                          <Alert
                            severity="warning"
                            icon={<WarningAmberOutlinedIcon />}
                            sx={{ my: 2, borderRadius: "10px" }}
                          >
                            Your previous identity verification was declined. Please complete a new verification below.
                          </Alert>
                        )}
                        <SelfieCaptureStep
                          defaultValue={selfieCapture}
                          isFirstStep={false}
                          isLastStep={false}
                          onSubmit={handleSelfieCapture}
                          onBack={prevFormStep}
                        />
                      </Box>
                    )}

                    {/* ── KYC: NIC/Passport/Driver License Check (REQUIRED / DECLINED only) ── */}
                    {needsKycCapture && formStep === documentStep && (
                      <Box sx={{ py: 2 }}>
                        {kycError && (
                          <Alert severity="error" sx={{ mb: 2, borderRadius: "10px" }}>
                            {kycError}
                          </Alert>
                        )}

                        {/* Capture UI — shown until /kyc/submit fires successfully */}
                        {!kycSubmitted &&
                          user?.kycStatus !== KycStatus.KYC_PENDING &&
                          user?.kycStatus !== KycStatus.KYC_VERIFIED && (
                            <DocumentUploadStep
                              defaultValue={null}
                              isFirstStep={false}
                              isLastStep={true}
                              isSubmitting={kycSubmitting}
                              onSubmit={handleDocumentSubmit}
                              onBack={prevFormStep}
                            />
                          )}

                        {/* After submission — pending verification.
                            kycSubmitted shows this immediately post-submit;
                            it stays while user.kycStatus === KYC_PENDING. */}
                        {(kycSubmitted || user?.kycStatus === KycStatus.KYC_PENDING) &&
                          user?.kycStatus !== KycStatus.KYC_VERIFIED && (
                            <Box
                              sx={{
                                bgcolor: "common.white",
                                borderRadius: "20px",
                                px: { xs: "18px", md: "24px" },
                                py: { xs: "24px", md: "24px" },
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "20px",
                                textAlign: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  bgcolor: "common.black",
                                  borderRadius: "32px",
                                  p: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <AccessTimeOutlinedIcon
                                  sx={{ fontSize: 56, color: "white" }}
                                  style={{ color: "white" }}
                                />
                              </Box>
                              <Typography
                                sx={{
                                  fontFamily: "'IBM Plex Mono', monospace",
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  lineHeight: "19.2px",
                                  textTransform: "uppercase",
                                  color: "common.black",
                                }}
                              >
                                Verification In Progress
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  lineHeight: "19.2px",
                                  color: "common.black",
                                  maxWidth: 480,
                                }}
                              >
                                Your documents are being verified. Please wait — this page will update automatically
                                once the result is available.
                              </Typography>
                              {kycPassed === false && kycFailureReasons && kycFailureReasons.length > 0 && (
                                <Alert severity="error" sx={{ mt: 2, borderRadius: "10px", textAlign: "left" }}>
                                  Verification failed: {kycFailureReasons.join(", ")}
                                </Alert>
                              )}
                            </Box>
                          )}

                        {/* After submission — passed; the user has been moved to KYC_VERIFIED */}
                        {user?.kycStatus === KycStatus.KYC_VERIFIED && (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              py: { xs: 9, md: 12 },
                              gap: 2,
                              textAlign: "center",
                            }}
                          >
                            <Box
                              sx={{
                                bgcolor: "#e8f5e9",
                                borderRadius: "50%",
                                p: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CheckCircleOutlineIcon sx={{ fontSize: 56, color: "#2e7d32" }} />
                            </Box>
                            <Text larger bold sx={{ mt: 1 }}>
                              Identity Verified
                            </Text>
                            <Text medium sx={{ maxWidth: 480, color: "text.primary" }}>
                              Your identity has been successfully verified. You can continue with the application.
                            </Text>
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* ── KYC: Merged Status Step (PENDING / VERIFIED only) ── */}
                    {showsKycStatusStep && formStep === kycStatusStep && (
                      <Box sx={{ py: 2 }}>
                        {user?.kycStatus === KycStatus.KYC_PENDING && (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              py: { xs: 4, md: 12 },
                              gap: 2,
                              textAlign: "center",
                            }}
                          >
                            <Box
                              sx={{
                                bgcolor: "white",
                                borderRadius: "50%",
                                p: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <svg
                                width="64"
                                height="64"
                                viewBox="0 0 64 64"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <rect width="64" height="64" rx="32" fill="black" />
                                <path
                                  d="M31.9741 8.66602C19.0941 8.66602 8.66406 19.1193 8.66406 31.9993C8.66406 44.8793 19.0941 55.3327 31.9741 55.3327C44.8774 55.3327 55.3307 44.8793 55.3307 31.9993C55.3307 19.1193 44.8774 8.66602 31.9741 8.66602ZM31.9974 50.666C21.6841 50.666 13.3307 42.3127 13.3307 31.9993C13.3307 21.686 21.6841 13.3327 31.9974 13.3327C42.3107 13.3327 50.6641 21.686 50.6641 31.9993C50.6641 42.3127 42.3107 50.666 31.9974 50.666ZM33.1641 20.3327H29.6641V34.3327L41.9141 41.6827L43.6641 38.8127L33.1641 32.5827V20.3327Z"
                                  fill="white"
                                />
                              </svg>
                            </Box>
                            <Text larger bold sx={{ mt: 1 }}>
                              Verification Pending
                            </Text>
                            <Text medium sx={{ maxWidth: 480, color: "text.primary" }}>
                              Your identity verification is currently under review. You will receive an update via email
                              once it's complete. You cannot proceed until verification is approved.
                            </Text>
                          </Box>
                        )}

                        {user?.kycStatus === KycStatus.KYC_VERIFIED && (
                          <Box
                            sx={{
                              bgcolor: "common.white",
                              borderRadius: "20px",
                              px: { xs: "18px", md: "24px" },
                              py: { xs: "24px", md: "24px" },
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <Box
                              sx={{
                                bgcolor: "#e8f5e9",
                                borderRadius: "32px",
                                p: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CheckCircleOutlineIcon sx={{ fontSize: 56, color: "#2e7d32" }} />
                            </Box>
                            <Typography
                              sx={{
                                fontFamily: "'IBM Plex Mono', monospace",
                                fontWeight: 700,
                                fontSize: "14px",
                                lineHeight: "19.2px",
                                textTransform: "uppercase",
                                color: "common.black",
                              }}
                            >
                              Identity Verified
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "19.2px",
                                color: "common.black",
                                maxWidth: 480,
                              }}
                            >
                              Your identity has been successfully verified. You're all set to continue with the
                              application.
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    )}

                    {formStep === orgInfoStep && (
                      <Box
                        sx={{
                          bgcolor: "common.white",
                          borderRadius: "20px",
                          px: { xs: "18px", md: "24px" },
                          pt: { xs: "18px", md: "24px" },
                          pb: { xs: "18px", md: "24px" },
                          display: "flex",
                          flexDirection: "column",
                          gap: "24px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "19.2px",
                            color: "common.black",
                          }}
                        >
                          Organization Information
                        </Typography>

                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                            gap: "24px",
                          }}
                        >
                          <Field
                            disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                            formAPI={form}
                            label="Name of organization"
                            name="name"
                            type="text"
                            component={TextFieldControlSimple}
                            validate={FormValidators.required("")}
                          />
                          <Field
                            disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                            formAPI={form}
                            label="Select country"
                            name="country"
                            type="text"
                            renderIcon={(item: any) => <img width="20px" src={item.icon} alt={item.label} />}
                            component={SelectFieldControl}
                            options={countriesList}
                            validate={FormValidators.required("")}
                          />
                          <Field
                            disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                            formAPI={form}
                            label="Address"
                            name="address"
                            type="text"
                            component={TextFieldControlSimple}
                            validate={FormValidators.required("")}
                          />
                          <Field
                            disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                            formAPI={form}
                            label="Website"
                            name="website"
                            type="text"
                            component={TextFieldControlSimple}
                            validate={FormValidators.required("")}
                          />
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "150px 1fr",
                              gap: "24px",
                            }}
                          >
                            <Field
                              disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                              formAPI={form}
                              label="Country code"
                              name="phoneCode"
                              type="text"
                              component={SelectFieldControl}
                              partialValue
                              options={codes}
                              validate={FormValidators.required(" ")}
                            />
                            <Field
                              disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                              formAPI={form}
                              label="Phone Number"
                              name="phone"
                              type="text"
                              component={TextFieldControlSimple}
                              validate={FormValidators.required("")}
                            />
                          </Box>
                          <Field
                            disabled={loading || (isInvitedTrustee && !isDeclinedOrgCreator)}
                            formAPI={form}
                            label="Email"
                            name="email"
                            type="text"
                            component={TextFieldControlSimple}
                            validate={FormValidators.required("")}
                          />
                        </Box>

                        <Typography
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "19.2px",
                            color: "common.black",
                          }}
                        >
                          Proof of Environmental Organization
                        </Typography>

                        <Grid container spacing={"24px"}>
                          <Grid item xs={12} md={6}>
                            {user?.organization?.proofOfAddress && !isDeclinedOrgCreator ? (
                              <ProofOfIdUpload
                                currentFile={user?.organization?.proofOfAddress}
                                sx={{ minHeight: "auto", height: "auto" }}
                              />
                            ) : (
                              <Box sx={{ "& > div": { margin: "0 !important" } }}>
                                <DocUploadNew
                                  disabled={isInvitedTrustee && !isDeclinedOrgCreator}
                                  heading="Upload Registration of Environmental Organization"
                                  acceptOnlyImages
                                  acceptImages
                                  file={proofOfAddress}
                                  setFile={setProofOfAddress}
                                />
                              </Box>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Box
                              sx={{
                                width: "100%",
                                backgroundColor: "back.infoCard",
                                borderRadius: "16px",
                                p: { xs: "20px", md: "24px" },
                                display: "flex",
                                gap: { xs: "12px", md: "16px" },
                                alignItems: "flex-start",
                              }}
                            >
                              <Box
                                sx={{
                                  flexShrink: 0,
                                  backgroundColor: "#d1efff",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: { xs: "36px", md: "40px" },
                                  height: { xs: "36px", md: "40px" },
                                }}
                              >
                                <InfoIconOutlined sx={{ fontSize: { xs: "20px", md: "22px" } }} color="primary" />
                              </Box>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", flex: 1, minWidth: 0 }}>
                                <Typography
                                  sx={{
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    fontWeight: 700,
                                    fontSize: "14px",
                                    lineHeight: "19.2px",
                                    textTransform: "uppercase",
                                    color: "common.black",
                                  }}
                                >
                                  Need Guidance?
                                </Typography>
                                <Typography
                                  sx={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    color: "common.black",
                                  }}
                                >
                                  Verifying the organization behind each uploaded land is crucial for building trust and
                                  ensuring legitimacy. This process involves checking provided documents such as
                                  registration certificates, business licenses, or tax identification numbers. By
                                  confirming the authenticity of these documents, we can ensure that only credible
                                  organizations are assessed, fostering a trustworthy environment for all stakeholders.
                                  This verification not only legitimizes the assessments but also enhances transparency
                                  in our platform.
                                </Typography>
                                <Box
                                  component="a"
                                  href={AppRoutes.About.path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    lineHeight: "16.8px",
                                    letterSpacing: "0.084px",
                                    textTransform: "uppercase",
                                    color: "common.black",
                                    textDecoration: "underline",
                                    textUnderlineOffset: "2px",
                                  }}
                                >
                                  Read More
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {formStep === userInfoStep && (
                      <>
                        {/* On md+ both column headings share the divider band, so the rule runs under the
                            pair and each column below starts straight at its content (fields / drop zone).
                            The halves mirror the Grid below: the band's 24px padding + two `flex: 1` cells
                            puts the second heading exactly at the 50% mark where the upload column begins.
                            On xs the columns stack, so the upload heading moves back down to sit directly
                            above the drop zone (see the upload Grid item). */}
                        <Attention sx={{ p: { xs: "18px", md: "24px" }, display: { md: "flex" } }}>
                          <Box sx={{ flex: 1 }}>User Account Information</Box>
                          <Box sx={{ flex: 1, display: { xs: "none", md: "block" } }}>Upload profile picture</Box>
                        </Attention>
                        <Grid container gap={{ xs: 2, md: "0px" }}>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: { xs: "16px", md: "auto" },
                              p: { md: "24px", xs: "12px" },
                              // Top-align with the profile-picture column. This used to be `margin: auto`,
                              // which centred the column vertically and left a dead band above Email
                              // whenever the form is shorter than the upload box — e.g. invited Trust
                              // Admins, who don't get the Active Region field.
                              alignSelf: { md: "flex-start" },
                            }}
                          >
                            <Section>
                              <Field
                                formAPI={form}
                                showDirty={true}
                                label="Email"
                                name="userEmail"
                                disabled={user?.emailVerified}
                                type="text"
                                component={TextFieldControlSimple}
                                validate={FormValidators.required("")}
                              />
                            </Section>
                            <Section>
                              <Field
                                formAPI={form}
                                showDirty={true}
                                label="Full name"
                                name="userName"
                                type="text"
                                component={TextFieldControlSimple}
                                validate={FormValidators.required("")}
                              />
                            </Section>

                            <SectionRow
                              sx={{
                                gridTemplateColumns: { xs: "1fr", md: "1fr 150px 1fr" },
                                marginTop: { xs: "12px", md: "0px" },
                                gap: { xs: "12px", md: "20px" },
                              }}
                            >
                              <Section sx={{ pt: { xs: "0px" } }}>
                                <Field
                                  formAPI={form}
                                  showDirty={true}
                                  label="Country"
                                  onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setCountry(e.target.value)}
                                  name="userCountry"
                                  type="text"
                                  component={SelectFieldControl}
                                  options={countriesList}
                                  renderIcon={(item: any) => <img width="20px" src={item.icon} alt={item.label} />}
                                  validate={FormValidators.required("")}
                                />
                              </Section>
                              <Section>
                                <Field
                                  disabled={loading}
                                  label="Country code"
                                  name="userPhoneCode"
                                  formAPI={form}
                                  type="text"
                                  component={SelectFieldControl}
                                  partialValue
                                  // renderIcon={(item: any) => <img width="20px" src={item.icon}
                                  //   alt={item.label} />}
                                  options={codes}
                                  validate={FormValidators.required(" ")}
                                />
                              </Section>
                              <Section>
                                <Field
                                  formAPI={form}
                                  showDirty={true}
                                  label="Phone number"
                                  name="userPhone"
                                  type="phone"
                                  component={TextFieldControlSimple}
                                  validate={FormValidators.required("")}
                                />
                              </Section>
                            </SectionRow>
                            {!isInvitedAdmin && (
                              <Section>
                                <Field
                                  showDirty={true}
                                  label="Active Region"
                                  name="patronymic"
                                  formAPI={form}
                                  type="text"
                                  partialValue
                                  component={SelectFieldControl}
                                  options={regions}
                                  validate={FormValidators.required(" ")}
                                />
                              </Section>
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            // Top-aligned to match the fields column (see its `alignSelf` note). The md top
                            // padding is the fields column's 24px + the first `Section`'s 24px, so the drop
                            // zone's top edge lines up with the Email field now that the heading lives in
                            // the divider band.
                            sx={{ alignSelf: { md: "flex-start" }, p: { md: "48px 24px 24px 0", xs: "18px" } }}
                          >
                            {/* xs only — on md+ this heading is in the divider band above. Plain text (not
                                `Text medium`, which drops to 14px under 992px) so it inherits the band's 16px
                                and matches "User Account Information" exactly. */}
                            <Attention sx={{ borderBottom: "none", display: { md: "none" } }}>
                              <Box sx={{ pt: 2 }}>Upload profile picture</Box>
                            </Attention>
                            <ProfilePictureUpload
                              key={`profile-picture-${user?.profilePicture || "none"}`}
                              onFileSelect={setProfilePic}
                              currentImage={user?.profilePicture}
                              onUpload={handleUploadPicture}
                              onDelete={handleDeletePicture}
                              loading={loading}
                            />
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {formStep === wetInkStep && (
                      <Box
                        sx={{
                          bgcolor: "common.white",
                          borderRadius: "20px",
                          px: { xs: "18px", md: "24px" },
                          pt: { xs: "18px", md: "24px" },
                          pb: { xs: "18px", md: "24px" },
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "19.2px",
                            color: "common.black",
                          }}
                        >
                          Download the conservation trust deed, hand-sign it, then upload the scan for automated
                          verification. Once it's verified you can review and submit your application.
                        </Typography>
                        <WetInkFlow
                          type={wetInkDocumentType}
                          templateVars={buildWetInkTemplateVars(values)}
                          onCompleted={() => setHasCompletedWetInk(true)}
                        />
                      </Box>
                    )}
                    {formStep === signAgreementStep && (
                      <VerifierEngagementStep
                        verifierName={values?.userName || user?.name || ""}
                        organisationName={values?.name || user?.organization?.name || ""}
                        signedDocumentId={signedEngagementId}
                        onSigned={setSignedEngagementId}
                      />
                    )}
                    {formStep === confirmStep && (
                      <Box
                        sx={{
                          bgcolor: "#d7eefd",
                          borderRadius: "20px",
                          px: { xs: "18px", md: "24px" },
                          pt: { xs: "18px", md: "24px" },
                          pb: { xs: "18px", md: "24px" },
                          display: "flex",
                          flexDirection: "column",
                          gap: "24px",
                        }}
                      >
                        <Grid container spacing={"24px"}>
                          <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                              <Typography
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  lineHeight: "19.2px",
                                  color: "common.black",
                                }}
                              >
                                Double check all your information.
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  lineHeight: "19.2px",
                                  color: "common.black",
                                }}
                              >
                                You're about to submit your organization details for EcoFutures{" "}
                                {isInvitedAdmin ? "Trust Admin" : "Trust"} status. This action will onboard you to the
                                platform.
                                {signsEngagement &&
                                  " Your Trust Admin will review your details and execute the Deed of Appointment of Sub-Attorney with you before approving. Once they approve you, you're a Verifier — there's nothing more to sign."}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Box
                              sx={{
                                width: "100%",
                                bgcolor: "#f2f2f2",
                                borderRadius: "16px",
                                p: { xs: "20px", md: "24px" },
                                display: "flex",
                                gap: { xs: "16px", md: "24px" },
                                alignItems: "flex-start",
                              }}
                            >
                              <Box
                                sx={{
                                  flexShrink: 0,
                                  width: 52,
                                  height: 52,
                                  borderRadius: "26px",
                                  bgcolor: "#d1efff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <InfoIconOutlined sx={{ fontSize: 28, color: "common.black" }} />
                              </Box>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", flex: 1, minWidth: 0 }}>
                                <Typography
                                  sx={{
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    fontWeight: 700,
                                    fontSize: "14px",
                                    lineHeight: "19.2px",
                                    textTransform: "uppercase",
                                    color: "common.black",
                                  }}
                                >
                                  What's the next step?
                                </Typography>
                                <Typography
                                  sx={{
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    color: "common.black",
                                  }}
                                >
                                  After submitting your request, your application will be processed. You will receive an
                                  email confirmation once approved. Approved organizations will be added to the platform
                                  and your team will be able to link their wallets.
                                </Typography>
                                <Box
                                  component="a"
                                  href={AppRoutes.About.path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    lineHeight: "19.2px",
                                    textTransform: "uppercase",
                                    color: "common.black",
                                    textDecoration: "underline",
                                    textUnderlineOffset: "2px",
                                  }}
                                >
                                  Read More
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                        {isKycBlockedAtConfirmStep && (
                          <Alert
                            severity={user?.kycStatus === KycStatus.KYC_DECLINED ? "error" : "warning"}
                            sx={{ borderRadius: "10px" }}
                          >
                            {kycConfirmStepMessage}
                          </Alert>
                        )}
                        {formError && (
                          <Alert severity="error" sx={{ borderRadius: "10px" }}>
                            {formError}
                          </Alert>
                        )}
                      </Box>
                    )}
                    {/* Hide outer Back/Next on liveliness step and on document step
                        during the capture phase — those steps drive their own navigation
                        via their internal StepNavigation. After /kyc/submit fires
                        (kycSubmitted) the document step transitions to a status screen;
                        the outer buttons return so the user can advance once verified. */}
                    {!(needsKycCapture && formStep === livelinessStep) &&
                      !(
                        needsKycCapture &&
                        formStep === documentStep &&
                        !kycSubmitted &&
                        user?.kycStatus !== KycStatus.KYC_PENDING &&
                        user?.kycStatus !== KycStatus.KYC_VERIFIED
                      ) && (
                        <StepButtons sx={{ padding: { xs: "18px", md: "24px" } }}>
                          <ActionBtn
                            onClick={() => prevFormStep()}
                            style={{ visibility: formStep === 1 ? "hidden" : "visible" }}
                            sx={{
                              height: 40,
                              borderRadius: 20,
                              fontFamily: "'Inter', sans-serif",
                              fontSize: 14,
                              fontWeight: 400,
                              textTransform: "none",
                              border: "none",
                              backgroundColor: "black",
                              color: "white",
                              "&:hover": { backgroundColor: "#333", border: "none", color: "white" },
                              "&.Mui-disabled": {
                                backgroundColor: "rgba(0,0,0,0.4)",
                                color: "rgba(255,255,255,0.6)",
                              },
                            }}
                          >
                            Back
                          </ActionBtn>
                          <ActionBtn
                            type={"button"}
                            onClick={async () => {
                              if (formStep === 1) {
                                // Only call create-applicant when KYC is required or declined.
                                if (needsKycCapture) {
                                  const ok = await handleCreateApplicant();
                                  if (!ok) return;
                                }
                                nextFormStep();
                                return;
                              }
                              if (formStep !== confirmStep) {
                                nextFormStep();
                              } else {
                                handleSubmit();
                              }
                            }}
                            disabled={buttonDisabled(invalid)}
                            sx={{
                              height: 40,
                              borderRadius: 20,
                              fontFamily: "'Inter', sans-serif",
                              fontSize: 14,
                              fontWeight: 400,
                              textTransform: "none",
                              border: "none",
                              backgroundColor: "black",
                              color: "white",
                              "&:hover": { backgroundColor: "#333", border: "none", color: "white" },
                              "&.Mui-disabled": {
                                backgroundColor: "rgba(0,0,0,0.4)",
                                color: "rgba(255,255,255,0.6)",
                              },
                            }}
                          >
                            {formSuccess
                              ? "Success"
                              : formStep === 1
                              ? creatingApplicant
                                ? "Starting…"
                                : "Get Started"
                              : formStep === documentStep &&
                                (kycSubmitted || user?.kycStatus === KycStatus.KYC_PENDING) &&
                                user?.kycStatus !== KycStatus.KYC_VERIFIED
                              ? "Waiting for verification…"
                              : formStep === confirmStep
                              ? loading
                                ? "Loading"
                                : "Confirm"
                              : "Next"}
                          </ActionBtn>
                        </StepButtons>
                      )}

                    {formSuccess && (
                      <>
                        <Divider sx={{ marginTop: 13, marginBottom: 13 }} />
                        <Text medium>
                          Please wait for our team to perform organization verification. It will be done soon!
                        </Text>
                      </>
                    )}
                  </FormArea>
                );
              }}
            />
          </FormContainer>

          <Trending sx={{ position: "relative", borderRadius: "20px" }}>
            <img src={PalmTree} alt="Jungle" style={{ width: "100%", height: "auto" }} />
            <BlogStoryBlock
              sx={{
                zIndex: 1,
              }}
              blog={posters[3]}
              search={posters[3]?.path}
            />
          </Trending>
        </StyledGrid>
      </Grid>
    );
  } else {
    return <UnauthorizedComponent />;
  }
};

const FormArea = styled("form")``;

const StepButtons = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const FormContainer = styled("div")``;

const InfoContainer = styled("div")`
  display: flex;
  flex-direction: column;
  & > span:not(:last-child) {
    margin-bottom: 12px;
  }
`;
const StyledGrid = styled(Grid)`
  margin: 0 auto;
  width: 100%;
  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const Attention = styled<any>("div")((props) =>
  props.theme.unstable_sx({
    color: props.inverted ? (props.theme.palette.mode === "dark" ? "text.secondary" : "text.primary") : "text.primary",
    fontSize: props.theme.spacing(8),
    width: "100%",
    paddingY: sizing(6),
    borderBottom: "1px solid",
    borderBottomColor: props.theme.palette.border.default,
  })
);

export default BecomeTrust;
